import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import Tabs from "../../components/Tabs";

import { useSnackbar } from "notistack";
import { useEffect, useMemo } from "react";
import { useNavigate, useSearchParams } from "react-router";
import Integrations from "../../features/integrations/user";
import { MailingIntegration } from "../../features/integrations/user/Mailing";
import { CheckConnection } from "../../features/integrations/user/Mailing/CheckConnection";
import { MicrosoftOauth } from "../../features/integrations/user/MicrosoftOauth";
import { useGetCurrentUserQuery } from "../../features/user/userApiSlice";

const UserIntegrations = () => {
	const { t } = useTranslation();
	const { enqueueSnackbar } = useSnackbar();

	const {
		data: user,
		isLoading: isLoadingUser,
		isFetching: isFetchingUser,
	} = useGetCurrentUserQuery(undefined);

	const hasActiveMicrosoftOauth = useMemo(() => {
		return user?.mailingSettings?.microsoftOauthActive;
	}, [user]);

	const hasActiveSMTPConnection = useMemo(() => {
		return (
			user?.mailingSettings?.emailReplyFrom &&
			user?.mailingSettings?.emailUsername &&
			user?.mailingSettings?.smtpHost &&
			user?.mailingSettings?.smtpPort &&
			user?.mailingSettings?.smtpEncryption &&
			user?.mailingSettings?.smtpValidateCert !== 0
		);
	}, [user]);

	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const oauthStatus = searchParams.get("microsoft-oauth");

	useEffect(() => {
		if (oauthStatus === "1") {
			enqueueSnackbar(t("ms_oauth_success_info"), {
				variant: "success",
			});
			searchParams.delete("microsoft-oauth");
			navigate({ search: searchParams.toString() }, { replace: true });
		}
		if (oauthStatus === "0") {
			enqueueSnackbar(t("ms_oauth_failure_info"), {
				variant: "error",
			});
			searchParams.delete("microsoft-oauth");
			navigate({ search: searchParams.toString() }, { replace: true });
		}
	}, [oauthStatus]);

	const tabs = [
		{
			label: t("menu_stocks"),
			content: (
				<Integrations
					user={user}
					isLoadingUser={isLoadingUser || isFetchingUser}
				/>
			),
		},
		{
			label: t("mailing"),
			content: (
				<Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
					<MicrosoftOauth
						isLoadingUser={isLoadingUser || isFetchingUser}
						hasActiveMicrosoftOauth={hasActiveMicrosoftOauth}
						hasActiveSMTPConnection={hasActiveSMTPConnection}
					/>
					<MailingIntegration
						user={user}
						isLoadingUser={isLoadingUser || isFetchingUser}
						hasActiveMicrosoftOauth={hasActiveMicrosoftOauth}
						hasActiveSMTPConnection={hasActiveSMTPConnection}
					/>
					{(hasActiveMicrosoftOauth || hasActiveSMTPConnection) && (
						<CheckConnection />
					)}
				</Box>
			),
		},
	];

	return <Tabs ariaLabel={t("integrations_label")} tabs={tabs} />;
};

export default UserIntegrations;
